import { DialogService, GridButton } from '@eforall/dashboard';
import { DialogMode } from '@interfaces';
import { BaseEngagementService } from '../../../../../services';
import { EngagementEditorDialog, EngagementEditorDialogData } from '../../../dialog';


export function getButtons(pageService: BaseEngagementService, dialogService: DialogService) {
	const buttons: GridButton[] = [
		{
			iconClass: 'fa-plus',
			label: 'Add Engagement',
			execute: async () => {
				const dialogData: EngagementEditorDialogData = {
					mode: DialogMode.ADD,
					staffRoleId: pageService.staffRoleId()!,
					externalRoleId: pageService.externalRoleId?.(),
				};
				const dialogAction = await dialogService.showCustom(EngagementEditorDialog, { data: dialogData }, 650, 800);

				// If save succeeds, callbackResult contains the created engagementId; otherwise, it is undefined.
				if (dialogAction?.callbackResult) {
					await pageService.areaService?.reloadData();
				}
			}
		},
	];

	return buttons;
}